var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"dynamic-list-toolbar-extensions"},_vm._l((_vm.resolvedExtensions),function(ext,idx){return _c(ext.component,{key:`list-toolbar-ext-${idx}`,tag:"component",attrs:{"selected-item-ids":_vm.selectedItemIds,"model-name":_vm.modelName,"items":_vm.items,"is-trash-view":_vm.isTrashView,"is-archive-view":_vm.isArchiveView}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }